import axios from "axios";
import { AnalyticsApi } from "../../../../apis/AnalyticsApi";
import { CustomBackdropController } from "../../../../components/backdrop/default/v1";
import { customToast } from "../../../../components/toast/custom-react-toastify/v1";
import { useApiInfoContextValueHook } from "../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../utils/sellertool-signature-utils";
import { useStockCycleDatasActionsContextHook } from "../contexts/StockCycleDatasContext";
import { v4 as uuidv4 } from 'uuid';
import { useSheetItemListActionsContextHook } from "../contexts/SheetItemListContext";
import { ANALYSIS_VERSIONS, DEFAULT_ANALYSIS_VERSION } from "../variables/analysisVersions";
import { STOCK_CYCLE_DATA_SERVICE } from "../service/stockCycleDataService";

const spreadsheetId = '1fonCAvWuSl6PhWGeB_SPn25FJ_Zebxdqz4ujbPboLks';
const GOOGLE_SHEETS_API_KEY = 'AIzaSyA8P2TGBs5yj0oDRPd3k2Z_iyaOH2hly2M';

export function useCustomFetcher(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const stockCycleDatasActionsContextHook = useStockCycleDatasActionsContextHook();
    const sheetItemListActionsContext = useSheetItemListActionsContextHook();

    const onFetchStockCycleDatas = async (settingVariables, analysisVersion = DEFAULT_ANALYSIS_VERSION) => {
        if (!settingVariables?.productCategoryIds || settingVariables?.productCategoryIds.length === 0) {
            customToast.error('카테고리를 선택해주세요.');
            return;
        }

        if (!settingVariables?.targetDOS || settingVariables?.targetDOS < 0) {
            customToast.error('목표 재고소진 기간을 입력해주세요.');
            return;
        }
        if (settingVariables?.daysOfLeadTime < 0) {
            customToast.error('리드타임을 정확히 입력해주세요.');
            return;
        }

        if (analysisVersion === ANALYSIS_VERSIONS.V3) {
            const invalidMultiplierLabel = V3_MULTIPLIER_FIELDS.find(field => !(Number(settingVariables?.[field.key]) > 0))?.name;
            if (invalidMultiplierLabel) {
                customToast.error(`${invalidMultiplierLabel}는 0보다 큰 숫자로 입력해주세요.`);
                return;
            }
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }


        if (analysisVersion === ANALYSIS_VERSIONS.V3) {
            const response = await AnalyticsApi().stockCycleV3({ params: settingVariables, headers: headers });
            if (response?.content) {
                stockCycleDatasActionsContextHook.stockCycleDatas.onSetByVersion(
                    ANALYSIS_VERSIONS.V3,
                    STOCK_CYCLE_DATA_SERVICE.normalizeV3Content(response?.content)
                );
            }
            return;
        }

        const response = await AnalyticsApi().stockCycle({ params: settingVariables, headers: headers });
        if (response?.content) {
            stockCycleDatasActionsContextHook.stockCycleDatas.onSetByVersion(
                ANALYSIS_VERSIONS.V2,
                STOCK_CYCLE_DATA_SERVICE.normalizeV2Content(response?.content)
            );
        }
    }

    const onFetchAlreadyPurchasedDatas = async () => {
        const sheetItemList = await Promise.all(ALREADY_PURCHASED_REQUESTS.map(async (request) => {
            return await axios.get(`https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${encodeURIComponent(request?.sheetName)}?key=${GOOGLE_SHEETS_API_KEY}`)
        }))
            .then(responses => {
                const dataList = [];
                responses.forEach((res, index1) => {
                    const values = res?.data?.values;
                    const sheetName = ALREADY_PURCHASED_REQUESTS[index1]?.sheetName;

                    const itemList = [];

                    if (values && values.length > 0) {
                        values.forEach((value, index2) => {
                            if (index2 === 0 || index2 === 1) {
                                return;
                            }
                            if (!value[0] || !value[3]) {
                                return;
                            }
                            itemList.push({
                                uuid: uuidv4(),
                                optionCode: value[0] ? value[0]?.trim() : '',
                                productName: value[2] || '',
                                productOptionName1: value[3] || '',
                                productOptionName2: value[4] || '',
                                quantity: value[5] || 0,
                            })
                        })
                    }

                    dataList.push({
                        sheetName: sheetName,
                        itemList: itemList
                    })
                })

                return dataList;
            })
            .catch(err => {
                console.log(err);
                customToast.error(`스프레드시트 불러오기에 실패 했습니다.\n${err}`)
            })

        if (sheetItemList) {
            sheetItemListActionsContext.sheetItemList.onSet(sheetItemList);
        }
    }

    return { onFetchStockCycleDatas, onFetchAlreadyPurchasedDatas }
}

const V3_MULTIPLIER_FIELDS = [
    { key: 'orderQtyMultiplier', name: '건당수량 중앙값 배수' },
    { key: 'highQuantileMultiplier', name: '건당수량 P90 배수' },
    { key: 'dailyRateMultiplier', name: '일평균 출고량 배수' }
]

const ALREADY_PURCHASED_REQUESTS = [
    {
        sheetName: '구매된 상품들',
    },
    {
        sheetName: '배송중',
    },
    {
        sheetName: '도착완료',
    },
    {
        sheetName: '서류작성',
    },
    {
        sheetName: '선적 +3days',
    }
]